import { reactive } from "vue";
import { lock, unlock } from "@js/utils/body-scroll-lock.js";

export const store = reactive({
	isMobileMenuOpen: false,
	openModal: null,
	modalConfig: {},
	// Dealer page hero expanded state
	heroExpanded: false,
});

export const mutations = {
	toggleMobileMenu() {
		store.isMobileMenuOpen = !store.isMobileMenuOpen;
		if (store.isMobileMenuOpen) {
			lock();
		} else {
			unlock();
		}
	},
	// Select-driven navigation on server-rendered lists (in-DOM templates cannot reach window)
	navigate(url) {
		window.location.assign(url);
	},
	openModal(id, config = {}) {
		if (store.openModal === null) {
			lock();
		}
		store.modalConfig = config;
		store.openModal = id;
	},
	closeModal(id) {
		if (id && id !== store.openModal) {
			return;
		}
		if (store.openModal !== null) {
			unlock();
		}
		store.openModal = null;
		store.modalConfig = {};
	},
};
